import types from "@/data/types"

const ticketGenerateValues = (type) => {
    switch (type) {
        case types.OSS_API:
        case types.OSS_APP:
        case types.OSS_WEB:
            return {
                barcode: true,
                onlyMobile: true,
                additional: true,
                cloakify: false,
            }
        case types.SG:
            return {
                barcode: true,
                onlyMobile: true,
                additional: false,
                cloakify: false,
            }
        case types.BALLPARK_APP:
            return {
                barcode: true,
                onlyMobile: false,
                additional: false,
                cloakify: false,

            }
        default:
            return {
                barcode: false,
                onlyMobile: false,
                additional: false,
                cloakify: false,
            }
    }
}

export default ticketGenerateValues